import { NotificationRepository, NotificationRequest } from '../NotificationRepository';

export class EnqueueNotificationUseCase {
  constructor(private repository: NotificationRepository) {}

  async execute(userId: string, type: string, payload: any): Promise<string> {
    if (!userId) {
      throw new Error('UserId is required for notification queueing');
    }
    
    const request: NotificationRequest = {
      type,
      payload: payload || {},
      sent: false
    };

    return await this.repository.enqueueRequest(userId, request);
  }
}
